import { isLocalhost } from "./debug";

export const turnOffAnimations = isLocalhost() || false;
// export const turnOffAnimations = true;
